<div class="sbac-root">
  <ng-container *ngFor="let bac of bacs">
    <rk-library-sbac-group
      *ngIf="bac.children && bac.children.length > 0"
      [bac]="bac"
    ></rk-library-sbac-group>

    <rk-library-sbac-item
      *ngIf="!bac.children || bac.children.length === 0"
      [bac]="bac"
    ></rk-library-sbac-item>
  </ng-container>
</div>
